import { useContext, useState } from 'react'
import { enqueueSnackbar } from 'notistack'

import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from '@mui/material'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'

import { AppContext } from '/providers/app-context'
import { notifyAll } from '/providers/passes-api'

const NotifyAllDialog = ({ open, setOpen, template }) => {

  const { apiSource, apiKeys, refreshTemplates, processing, setProcessing } = useContext(AppContext)
  
  const [notification, setNotification] = useState("")
  
  const notifyPasses = async () => {
    close()
    setProcessing(true)
    enqueueSnackbar({ message: 'Notifying passes', variant: 'light' })
    const result = await notifyAll({ apiSource, apiKeys, templateId: template.id, notification })

    if (result.error) {
      enqueueSnackbar({ message: error.message ?? 'Error queuing notifications', variant: 'error' })
    } else {
      enqueueSnackbar({ message: 'Notifications queued', variant: 'success' })
    }

    setProcessing(false)
    setNotification("")
    refreshTemplates()
  }

  const close = () => setOpen(false)

  if (template) return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Notify All Passes : {template.name}
      </DialogTitle>

      <DialogContent>
        <div style={{ width: 600 }} className='flex flex-col gap-5'>
          <p>This will send a notification to all issued passes.</p>

          <TextField value={notification} label="Notification text" sx={{width:550}} 
            onChange={e => setNotification(e.target.value.substring(0, 255))} 
            slotProps={{ inputLabel: { shrink: true } }}
            autoFocus
            type="search"/>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="flex flex-row justify-between w-full p-5">
          <Button variant="outlined" onClick={close} disabled={processing}>Cancel</Button>
          <Button variant="contained" onClick={notifyPasses} autoFocus disabled={processing || notification.length < 5}><SyncOutlinedIcon className="mr-5" />Notify All Passes</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default NotifyAllDialog